// This file is auto-generated. DO NOT EDIT THIS FILE MANUALLY!
//
// To regenerate this file, run yarn higharc gen doc-schema (which automatically updates this file)
// or run yarn higharc gen doc-schema-entity-mappings directly.

/**
 * Mapping from doc entity types to their corresponding schema names in DocSchemaLibrary.
 * Only includes entity types that exist in docSchemaEntityTypeMap.
 */
export const docEntityTypeToSchemaName = {
  ANNOTATION: "Annotation",
  ASSET: "Asset",
  BLOCK: "Block",
  CASEWORK: "WallCasework",
  CASEWORK_CATALOG_SETTINGS: "CaseworkCatalogSettings",
  CASEWORK_DESCRIPTOR: "CaseworkDescriptor",
  CEILING: "Ceiling",
  CIP_COMPONENT: "CipConcrete",
  COLUMN: "Column",
  COLUMN_CATALOG_SETTINGS: "ColumnCatalogSettings",
  COLUMN_DESCRIPTOR: "ColumnDescriptor",
  COMPONENT: "Component",
  COMPONENT_INSTANCE: "ComponentInstance",
  COMPOSITE_LEVEL: "CompositeLevel",
  CONTENT_REPLICATOR: "ContentReplicator",
  CONTENT_TEMPLATE: "ContentTemplate",
  CONTENT_TEMPLATE_INSTANCE: "ContentTemplateInstance",
  DATA_SEQUENCE: "DataSequence",
  DATA_TABLE: "DataTable",
  DOC_REF: "DocRef",
  DOOR_CATALOG_SETTINGS: "DoorCatalogSettings",
  DOOR_DESCRIPTOR: "DoorDescriptorCustom",
  DORMER: "RoofDormerPlacement",
  DRAWING: "Drawing",
  DRAWING_CATALOG_SETTINGS: "DrawingCatalogSettings",
  DRAWING_REF: "DrawingRef",
  EDGE_BEHAVIOR: "EdgeBehavior",
  EDGE_MODIFIER: "EdgeModifier",
  EFFECT: "Effect",
  ELECTRICAL_DEVICE: "ElectricalDevice",
  ELECTRICAL_ITEM_CATALOG_SETTINGS: "ElectricalItemCatalogSettings",
  ELECTRICAL_LAYOUT: "InPlaceElectricalLayout",
  ELECTRICAL_RULE: "ElectricalRule",
  ELEVATION: "Elevation",
  ELEVATION_VIEW: "ElevationView",
  ENTITY_SETTINGS: "EntitySettings",
  FACADE: "Facade",
  FACADE_SPAN_STRATUM: "FacadeSpanStratum",
  FACADE_SWEEP_STRATUM: "FacadeSweepStratum",
  FLOOR: "FloorAssemblyOverride",
  FLOOR_FINISH: "FloorAssemblyFinishLayerOverride",
  FLOOR_SYSTEM: "FloorSystemExternal",
  FOUNDATION: "Foundation",
  FOUNDATION_ASSEMBLY: "FoundationAssemblyEntity",
  FOUNDATION_COMPONENT: "FoundationComponentEntity",
  FOUNDATION_SYSTEM: "FoundationSystem",
  FRAME_FLOOR_ASSEMBLY: "FrameFloorAssemblyEntity",
  FRAMING_COMPONENT: "FramingComponentEntity",
  FREEFORM_WALL: "FreeformWallEntity",
  GLOBAL_PARAMETER: "GlobalParameter",
  GROUP: "Group",
  HEADER_ASSEMBLY: "HeaderAssemblyEntity",
  INSTANCE_OPTION_SET: "InstanceOptionSet",
  LABEL: "Label",
  LEVEL: "LevelDef",
  LOAD_DESCRIPTOR: "LoadDescriptor",
  LOCAL_PARAMETER: "LocalParameter",
  MASONRY_COMPONENT: "MasonryComponentEntity",
  MEASUREMENT: "PlanAreaMeasurement",
  MODIFIER: "Modifier",
  OPENING: "Opening",
  OPTION: "DocOption",
  OPTION_EFFECT: "DocOptionEffect",
  OPTION_LOCK: "DocOptionLock",
  OPTION_RULE: "DocOptionRule",
  OPTION_SET: "DocOptionSet",
  OPTION_SET_OVERRIDES: "DocOptionSetOverrides",
  OPTION_TEMPLATE: "DocOptionTemplate",
  PALETTE: "Palette",
  PLAN_SET_TEMPLATE: "PlanSetTemplate",
  PLAN_SET_TEMPLATE_CONFIG: "PlanSetTemplateConfig",
  PLAN_VIEW: "PlanView",
  PRESET: "Preset",
  PROFILE: "ProfileEntity",
  PROFILE_CATALOG_SETTINGS: "ProfileCatalogSettings",
  PROFILE_EXTRUSION_DESCRIPTOR: "ProfileExtrusionDescriptor",
  PROP: "PropAttributes",
  PROP_INSTANCE: "PropInstance",
  RAILING: "Railing",
  RAILING_CATALOG_SETTINGS: "RailingCatalogSettings",
  RAILING_POST: "PostPlacement",
  RAILING_SETTING: "RailingDefaultSetting",
  REFERENCE_GEOM: "ReferenceGeom",
  REPORTABLE_UNIT_DESIGNATION: "ReportableUnitDesignation",
  ROOF: "Roof",
  ROOF_OPENING: "RoofOpeningPlacement",
  ROOF_SIDE: "RoofSide",
  ROOF_SYSTEM: "RoofSystem",
  ROOF_VOLUME: "RoofVolume",
  ROOM: "StaticRoom",
  ROOM_LAYOUT: "RoomLayout",
  ROOM_LAYOUT_INSTANCE: "RoomLayoutInstance",
  RULE_BASED_SELECTOR: "RuleBasedSelector",
  RULE_BASED_SELECTOR_INSTANCE: "RuleBasedSelectorInstance",
  SECTION_VIEW: "SectionView",
  SELECTOR: "AutoDimensionSelector",
  SETTINGS: "SettingsFragment",
  SETTINGS_SET: "SettingsSet",
  SHEATHING_COMPONENT: "SheathingComponentEntity",
  SHEET: "Sheet",
  SITE: "Site",
  SITE_SHAPE: "SiteShape",
  SKYLIGHT: "SkylightPlacement",
  SLAB_COMPONENT: "SlabComponentEntity",
  SLAB_FLOOR_ASSEMBLY: "SlabFloorAssemblyEntity",
  STAIR_BLOCK: "StairBlock",
  STAIR_CATALOG_SETTINGS: "StairCatalogSettings",
  STAIR_SETTING: "StairSetting",
  STAIR_SYSTEM: "StairSystem",
  STRUCTURAL_MATERIAL: "StructuralMaterial",
  SYSTEM_PARAMETER: "SystemParameter",
  UNDERLAY: "Underlay",
  VIEW_3D: "View3D",
  VIEW_OVERRIDE: "ViewOverride",
  VIEW_SELECTOR: "ViewSelector",
  VIEW_TEMPLATE: "ViewTemplate",
  VIEW_TEMPLATE_OVERRIDE: "ViewTemplateOverride",
  VIEWPORT: "Viewport",
  WALL_CATALOG_SETTINGS: "WallCatalogSettings",
  WALL_PLANE_ASSEMBLY: "WallPlaneAssemblyEntity",
  WALL_PLANE_FILTER: "DocWallPlaneFilter",
  WALL_PLANE_RULE: "WallPlaneRuleEntity",
  WALL_PLANE_TRIM: "WallPlaneTrimEntity",
  WALL_TYPE: "WallType",
  WINDOW_CATALOG_SETTINGS: "WindowCatalogSettings",
  WINDOW_DESCRIPTOR: "WindowDescriptorCustom",
} as const;

// This file is auto-generated. DO NOT EDIT THIS FILE MANUALLY!
//
// To regenerate this file, run yarn higharc gen doc-schema (which automatically updates this file)
// or run yarn higharc gen doc-schema-entity-mappings directly.
